"use strict";
import {find} from "@elements/dom-utils";
import {getCoordinateValue} from "./outlineCoordinateParser";

export function update(configuration) {
    if (document.getElementById('outlineContainer')) {
        let boundingBox = document.getElementById('outlineContainer').getBBox();

        for (let item in configuration) {
            if (!configuration.hasOwnProperty(item)) {
                continue;
            }

            let scaleFactor = (Math.max(boundingBox.width, boundingBox.height) / 300);

            let x = getCoordinateValue(configuration[item].x);
            let y = getCoordinateValue(configuration[item].y);

            document.getElementById(item).setAttribute('transform', 'translate(' + (x + scaleFactor).toFixed(0) + ', ' + (y - scaleFactor).toFixed(0) + ') scale(' + scaleFactor.toFixed(2) + ',' + scaleFactor.toFixed(2) + ')');
        }
    }
}

export function rotate(angleDeg, configuration) {
    for (let item in configuration) {
        let letterNode = find('#' + item + '> *');
        letterNode.setAttribute('transform', 'rotate(' + angleDeg + ')');
        // letterNode.css('transform', 'rotate(' + angleDeg + 'deg)');
    }
}